export default __webpack_public_path__ + "static/media/picto_2.5b606eeb.png";